{
  "events": [
    {
      "title": "Ersti-Stammtisch",
      "subtitle": "Stammtisch Stammtisch!",
      "url": "lostlevel.bar",
      "location": "Lost Level Bar",
      "day": "2025-10-07",
      "time": "20:00:00.000",
      "enabled": true,
      "image": "/uploads/2025-07-10-ersti-stammtisch_optimized.jpg",
      "content": "Wir laden alle Erstis und Non-Erstis zum Beginn des neuen Semesters wieder herzlich dazu ein, am Dienstag, den 07.10.25 um 20 Uhr ins Lost Level zu kommen 🤩\n\nWie immer könnt ihr hier mit uns oder anderen aus den Studiengängen Medieninformatik und Informationsverarbeitung quatschen, zocken und trinken 😎\n\nWir freuen uns auf alle die vorbeischauen!🥳"
    }
  ],
  "members": [
    {
      "name": "Adriana Rieger",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/5f197e5ccad4f1496d758309_a6118f080e9747f2a8b66fd01b7dcd14_ca5eca4346_optimized.jpg",
      "priority": 50,
      "role": "Ehemaliges Fachschaftsmitglied",
      "content": "In der Fachschaft von WiSe 2019/20 bis SoSe 2022"
    },
    {
      "name": "Christina Schwarz",
      "formerMember": false,
      "enabled": true,
      "image": "/uploads/2d71343e_6416_4a00_b116_af87a3878ce9_5abde948c3_optimized.jpg",
      "priority": 50,
      "role": "Events",
      "content": "Nach Java reisen und den Brandberg besuchen~ \n\n[@2crispy4christy](https://instagram.com/2crispy4christy)\n"
    },
    {
      "name": "David Lazzarini",
      "formerMember": false,
      "enabled": true,
      "image": "/uploads/a7_00019_optimized.jpg",
      "priority": 2,
      "role": "2. Vorsitzender | Website-Pflege",
      "content": ""
    },
    {
      "name": "Dennis Bokov",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/dennis_9be23a8641_optimized.jpg",
      "priority": 4,
      "role": "Ehemaliger 1. Vorsitzender | Events",
      "content": "Friday ist Hypeday my Dudes :D\n"
    },
    {
      "name": "Felix Wanke",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/felix_479f17a6d6_optimized.jpg",
      "priority": 50,
      "content": "cash me outside, how bow da?\n\n[@wankovich](https://www.instagram.com/wankovich/)\n"
    },
    {
      "name": "Frederic Zeiger",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/5f39445e57942cf474edaaf0_selfie_frederic_a9556bad4f_optimized.jpg",
      "priority": 50,
      "role": "Ehemaliges Fachschaftsmitglied ",
      "content": "Frederic war vom WiSe 2019/20 bis WiSe 2024/25 aktives Mitglied der Fachschaft Medieninformatik/Informationsverarbeitung\n"
    },
    {
      "name": "Inez Keller",
      "formerMember": false,
      "enabled": true,
      "image": "/uploads/whatsapp-image-2026-09-04-at-13.50.34_optimized.jpg",
      "priority": 5,
      "role": "Events | Social Media",
      "content": "Studying and Sidequesting ✨\n"
    },
    {
      "name": "Jacqueline Engelhardt",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/5f197e51cad4f1496d758308_42dd2c77aeab4fcc9a0fde2f5f8f71bb_15ff0dbf1c_optimized.jpg",
      "priority": 50,
      "role": "Social Media",
      "content": "[@jacquelineengelhardt](http://instagram.com/jacquelineengelhardt)\n"
    },
    {
      "name": "Jago Neumann",
      "formerMember": false,
      "enabled": true,
      "image": "/uploads/18af9a62-952a-4624-a78a-d0307459f6c8-mainlane2000_optimized.jpg",
      "priority": 3,
      "role": "Kassenwart/Finanzer | IDH-Studierendenvertreter | Vorstand IDH",
      "content": "Höher, Breiter, Trittstufe Leiter"
    },
    {
      "name": "Jelde Schipper",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/whatsapp-image-2025-07-02-at-20.49.27_optimized.jpg",
      "priority": 4,
      "role": "Social Media | Studi-Kommunikation",
      "content": "Chillen ist am chilligsten\n"
    },
    {
      "name": "Judith Nester",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/5f197e6acad4f1496d75830b_5071292b6ebe4055bb832f33ddae78d7_43e43f4e40_optimized.jpg",
      "priority": 4,
      "role": "Ehemaliges Fachschaftsmitglied",
      "content": "In der Fachschaft von SS 2015 bis WS 2018/19. Judith war für ein Semester Vorsitzende, ab dann 2. Vorsitzende. "
    },
    {
      "name": "Julia Kampf",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/5f197dd4cad4f1496d758302_43c2c362642e42f596a404b49714ae65_690780e515_optimized.jpg",
      "priority": 50,
      "role": "Events | Social Media",
      "content": "Nenn mich Jule oder ich kämpf mit dir 🥊😤\n\n[@julee_ka](https://www.instagram.com/julee_ka/)\n"
    },
    {
      "name": "Kai Niebes",
      "formerMember": false,
      "enabled": true,
      "image": "/uploads/1681157056660_26d0203d3a_optimized.jpg",
      "priority": 10,
      "role": "Website",
      "content": "Langzeitstudent aus Leidenschaft 🤠\n\n[Check mein GitHub](https://github.com/HeyItsBATMAN)💻✨\n"
    },
    {
      "name": "Katrin Wilcken",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/5f197e3ecad4f1496d758306_cbed48afca5c4c01aed9a09f988d763a_500fe4f5aa_optimized.jpg",
      "priority": 50,
      "role": "Fachschaftsvertreterin (FSK)",
      "content": "[@katrin.wm 📸](https://www.instagram.com/katrin.wm/)\n"
    },
    {
      "name": "Kimon Gerken",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/whats_app_image_2019_09_29_at_19_25_47_617f4e9e52_optimized.jpg",
      "priority": 90,
      "content": "\n"
    },
    {
      "name": "Leon Wallmichrath",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/whats_app_image_2019_09_29_at_15_32_41_79488a01da_optimized.jpg",
      "priority": 4,
      "role": "Stellvertretender Kassenwart",
      "content": "*Hello, IT. Have you tried turning it off and on again 🤔?* \n"
    },
    {
      "name": "Levin Gjakonovski",
      "formerMember": false,
      "enabled": true,
      "image": "/uploads/50017a37_e104_4181_9577_eaaf8f1b3ed0_fe7bd3aabb_optimized.jpg",
      "priority": 50,
      "content": "I'm a legato guy.\n"
    },
    {
      "name": "Lukas Wilkens",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/5f197e47cad4f1496d758307_4183b7caae4c43b9b00eb12c2865e039_594154a4db_optimized.jpg",
      "priority": 3,
      "role": "Studierendenvertreter Vorstand IDH, Ehemaliger Vorsitzender",
      "content": "Anime was a mistake.\n\n[@wilkenlukas](https://www.instagram.com/wilkenlukas/)\n"
    },
    {
      "name": "Maja Grohs",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/5f186b4bb2cb29d0edd4188c_91a062f037114b0b9a386c1e15fc7b39_c86e0632d1_optimized.jpg",
      "priority": 1,
      "role": "Ehemalige Präsidentin & Ehrenvorsitzende",
      "content": "Torilla tavataan! ✨"
    },
    {
      "name": "Malte Rudius",
      "formerMember": false,
      "enabled": true,
      "image": "/uploads/malte_29447a9a3a_optimized.jpg",
      "priority": 1,
      "role": "1. Vorsitzender | Pflege des Mail-Verteilers | FSK, LSK",
      "content": "Das Vorratslager ist voll, my Lord.\n"
    },
    {
      "name": "Maria Wagner",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/5f197e63cad4f1496d75830a_988ab7baf2de466eb2e3682aceedef46_47f848e3ba_optimized.jpg",
      "priority": 2,
      "role": "Ehemalige Präsidentin",
      "content": "In der Fachschaft von 2012 bis 2018. Maria hat damals die Fachschaft neu mitgegründet. Präsidentin bis ca. 2015. "
    },
    {
      "name": "Marius Krämer",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/marius_24760e9f39_optimized.jpg",
      "priority": 50,
      "role": "Ersti-Guide | Fachschaftsvertreter (FSK)",
      "content": "Cogito, ergo Suff 🍻\n"
    },
    {
      "name": "Max Latz",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/5f253d36429047cd7d46bd72_5f197dbccad4f1496d7582ff_1cbe54ec89ec4f5fb1f531bae07eaf3c_png_dd3bdc4fb6_optimized.jpg",
      "priority": 50,
      "content": "Alles unter 200BPM ist für Kinder 👼🏻\n"
    },
    {
      "name": "Nadjim Noori",
      "formerMember": false,
      "enabled": true,
      "image": "/uploads/5f197dcbcad4f1496d758301_5464be4c33624c31bc560ceb5acf4c11_a4b9756ac8_optimized.jpg",
      "priority": 50,
      "content": "Khaq da saret ☺️\n\n[@nadjim.noori98](https://www.instagram.com/nadjim.noori98/)\n"
    },
    {
      "name": "Nasrin Saef",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/b618a8a3_a578_421a_bb46_0928db35f98e_330b6ba804_optimized.jpg",
      "priority": 3,
      "role": "Ehemaliges Fachschaftsmitglied",
      "content": "Nasrin war Mitglied vom WS 2012/13 bis zum WS 2018/19 und war somit Teil der Fachschaftswiederbelebung."
    },
    {
      "name": "Nelson Marambio",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/5f197e76cad4f1496d75830d_f6d565f49b2144ecb0e8b7c1527ddfc9_425aa7f91f_optimized.jpg",
      "priority": 1,
      "role": "Ehemaliges Fachschaftsmitglied",
      "content": "In der Fachschaft von WS 2010/11 bis SS 2015. Nelson hat damals die Fachschaft neu mitgegründet. Auch nach seiner aktiven Zeit war er ab und zu bei Stammtischen dabei.\n"
    },
    {
      "name": "Nghia Truong",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/deba08f1_4908_4393_87bf_a435ae8e426c_e5d8d5fd44_optimized.jpg",
      "priority": 50,
      "role": "Events",
      "content": "Der Klügere kippt nach\n\n[@nghiatrx](https://www.instagram.com/nghiatrx)"
    },
    {
      "name": "Patrick Jominet",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/1c503a12_411d_496d_9845_1c644c626999_a27d257c94_optimized.jpg",
      "priority": 6,
      "role": "Ehemaliger Kassenwart",
      "content": "In der Fachschaft von Anfang 2018 bis Ende 2019. Patrick war bei jedem (!) Stammtisch dabei und half seinen Kommiliton:innen, wenn es Fragen rund ums Programmieren gab."
    },
    {
      "name": "Till Pussel",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/dfbb649b_f9a9_4fc9_b170_5312be5820ac_b83520cc21_optimized.jpg",
      "priority": 50,
      "role": "Ersti-Guide",
      "content": "support your local dealer\n\n[@till_pussel](https://www.instagram.com/till_pussel/)\n"
    },
    {
      "name": "Tim Eron",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/100bf000_1551_400e_aef6_3e420e34077f_61c87b89a0_optimized.jpg",
      "priority": 50,
      "role": "Fachschaftsvertreter (FSK)",
      "content": "[@tim_mit_mittim](https://www.instagram.com/tim_mit_mittim/)\n"
    },
    {
      "name": "Timo Schumann",
      "formerMember": true,
      "enabled": true,
      "image": "/uploads/f2af50cd_d4ff_48fc_8863_42e66a2d06d8_49553cd200_optimized.jpg",
      "priority": 5,
      "role": "Ehemaliges Fachschaftsmitglied",
      "content": "In der Fachschaft von 2013 bis 2018. Timo hat damals die Fachschaft neu mitgegründet. Als Veteran ein gern gesehener Gast auf Stammtischen."
    },
    {
      "name": "Titus Jablonski",
      "formerMember": false,
      "enabled": true,
      "image": "/uploads/whatsapp-bild-2024-06-14-um-17.44.27_85174ab7-titus-jablonski_optimized.jpg",
      "priority": 5,
      "role": "Social Media",
      "content": "Good morning, and in case I don't see ya, good afternoon, good evening, and good night!\n\n[@titus.jablonski](https://www.instagram.com/titus.jablonski/)\n"
    }
  ],
  "studycontent": [
    {
      "title": "Hilfreiche Links",
      "enabled": true,
      "priority": 50,
      "content": "- [IDH](http://dh.uni-koeln.de/): Die Seite des Instituts für Digital Humanities\n- [KLIPS 2.0](https://klips2.uni-koeln.de/co/webnav.ini): Dort könnt ihr Kurse belegen, eure Prüfungsergebnisse sehen, euer Transcript herunterladen und vieles mehr. \n- [ILIAS](https://www.ilias.uni-koeln.de/): ILIAS ist die eLearning-Plattform der Uni. Dort findet ihr Folien, Präsentationen, Dokumente etc. zu euren Kursen.\n- [Digital Humanities Uni Köln](https://www.instagram.com/fsinfokoeln/): Unser Instagramkanal auf dem ihr auch unsere Ankündigungen findet.\n- [Unibibliothek](https://www.ub.uni-koeln.de/): Die Seite der Unibib. Dort könnt ihr nachschauen, ob und wo genau euer gewünschtes Buch vorhanden ist.\n- [Mensa](https://www.kstw.de/speiseplan): Speisepläne der Mensa. Die nächsten Mensen vom Hauptgebäude aus sind die große Mensa (Zülpicher Straße) und die Robert-Koch-Mensa (auch Roko-Mensa genannt). ",
      "sluggedTitle": "hilfreiche-links"
    },
    {
      "title": "Institut",
      "enabled": true,
      "priority": 6,
      "content": "Das **Institut für Digital Humanities (IDH)** befindet sich im 1. Obergeschoss der Universitätsstr. 22, direkt an der Haltestelle der Buslinien 130, 134 und 142. Die Geschäftszeiten und Sprechstunden findet ihr auf der [Seite des Instituts](https://dh.uni-koeln.de/).",
      "sluggedTitle": "institut"
    },
    {
      "title": "Ersti-Empfehlungen für das Wintersemester 2026/27 – Bachelor",
      "enabled": true,
      "priority": 1,
      "content": "Hier findet ihr eine Übersicht der Empfehlungen für Erstis des Wintersemesters 2026/2027 für die Studienfächer Medieninformatik und Informationsverarbeitung im Bachelor. Diese Übersicht ist allerdings nicht verbindlich und wir empfehlen euch, selbst bei KLIPS nachzuschauen. \n\n## Ersti-Empfehlungen\n\n### BM 1: Basisinformationstechnologie (BIT)\n**Vorlesung:** [161300111 Einführung in die Informationsverarbeitung](https://klips2.uni-koeln.de/co/ee/ui/ca2/app/desktop/#/slc.tm.cp/student/courses/564424?$scrollTo=toc_overview)\n\n**Seminar:** [161300112 Basisinformationstechnologie 1 (BIT 1)](https://klips2.uni-koeln.de/co/ee/ui/ca2/app/desktop/#/slc.tm.cp/student/courses/563024?$scrollTo=toc_overview)\n\n### BM 3: Programmierung (MI) | BM 4: Programmierung (IV)\n**Seminar:** [161300141 Softwaretechnologie: Java I ](https://klips2.uni-koeln.de/co/ee/ui/ca2/app/desktop/#/slc.tm.cp/student/courses/563647?$scrollTo=toc_overview)\n\n**Übung:** Praktische Umsetzung\n- [161300142 Programmierpraktikum: Java I bei Judith Nester](https://klips2.uni-koeln.de/co/ee/ui/ca2/app/desktop/#/slc.tm.cp/student/courses/563393?$scrollTo=toc_overview)\n- [161300143 Programmierpraktikum: Java I bei Sebastian Reimann](https://klips2.uni-koeln.de/co/ee/ui/ca2/app/desktop/#/slc.tm.cp/student/courses/564054?$scrollTo=toc_overview)\n\nStand: 26.08.26",
      "sluggedTitle": "ersti-empfehlungen-fur-das-wintersemester-202627-bachelor"
    },
    {
      "title": "Mailingliste",
      "enabled": true,
      "priority": 50,
      "content": "Meldet euch bei unserem Mailverteiler [miiv-info](https://lists.uni-koeln.de/mailman/listinfo/miiv-info) an, um Mails zu Kursen, Jobs und Praktika zu erhalten. Ihr könnt auch selbst eine Mail an den Verteiler zu den gleichen Themen schicken – zum Beispiel wenn ihr Nachhilfe sucht. ",
      "sluggedTitle": "mailingliste"
    },
    {
      "title": "Modulhandbücher",
      "enabled": true,
      "priority": 5,
      "content": "Hier findet ihr die Modulhandbücher. Wir versuchen diese immer uptodate zu halten. Im Notfall könnt ihr euch diese auch auf der Seite des Instituts und der Fakultät anschauen.\n\n## Medieninformatik\n**[Modulhandbuch für Medieninformatik (B.A.)](https://phil-fak.uni-koeln.de/sites/phil-fak/lehre_studium/bachelor/modulhandbuecher/2015BAVBMeWi.pdf)**\n\n**[Modulhandbuch für Medieninformatik (M.A.)](https://phil-fak.uni-koeln.de/sites/phil-fak/lehre_studium/master/modulhandbuecher/2015MAVBMeWi.pdf)**\n\n## Informationsverarbeitung\n**[Modulhandbuch für Informationsverarbeitung (B.A.)](https://phil-fak.uni-koeln.de/sites/phil-fak/lehre_studium/bachelor/modulhandbuecher/2015BA2FInfo.pdf)**\n\n**[Modulhandbuch für Informationsverarbeitung (M.A.)](https://phil-fak.uni-koeln.de/sites/phil-fak/lehre_studium/master/modulhandbuecher/2015MA1FInfo.pdf)**",
      "sluggedTitle": "modulhandbucher"
    },
    {
      "title": "PC-Pools",
      "enabled": true,
      "priority": 50,
      "content": "Falls ihr keinen Laptop besitzt und momentan an der Uni Zeit bis zum nächsten Kurs habt, könnt ihr auch an folgenden Orten einen Computer benutzen und Hausaufgaben erledigen:\n\n- [PC-Pool \\\"Forschendes Lernen\\\" (FL)](http://pcpools.phil-fak.uni-koeln.de/30912.html): Der PC-Pool befindet sich im Philosophikum (rote Tür, Glaskasten) und ist ausschließlich für Studierende der Philosophischen Fakultät. Unter dem Link findet ihr die Öffnungszeiten und genaue Lage.\n- [RRZK-Pool im Philosophikum](https://rrzk.uni-koeln.de/standorte-oeffnungszeiten.html#c11189): Den anderen Pool seht ihr direkt links vom Philo-Kiosk.\n- [Pool im RRZK](https://rrzk.uni-koeln.de/standorte-oeffnungszeiten.html)\n- [Computer in der Bibliothek](https://www.ub.uni-koeln.de/lernen_arbeiten/arbeitenusb/arbeitsplatz/index_ger.html)\n\nAchtet dabei immer darauf, wann die Pools geöffnet haben und ob es eventuelle Einschränkungen geben könnte. Teilweise könnt ihr auch in den Pools drucken, kopieren und scannen. Es gibt noch weitere PC-Pools, die sich an anderen Fakultäten befinden. ",
      "sluggedTitle": "pc-pools"
    },
    {
      "title": "Tipps",
      "enabled": true,
      "priority": 50,
      "content": "**Belegung von Kursen:** generell gilt: zuerst das kleine, dann das große Fach. Befindet ihr euch im Verbundstudium, belegt immer zuerst die Kurse für Medieninformatik, dann für Medienkulturwissenschaft. Selbst wenn ihr euch im Zweifachstudium befindet, ist die Wahrscheinlichkeit hoch, dass Medieninformatik bzw. Informationsverarbeitung das kleinere Studienfach ist und somit weniger Kurse zur Auswahl als das größere hat. Nachdem ihr die Kurse für MI oder IV belegt habt, könnt ihr mit der Belegung für das andere Studienfach beginnen.\n\n**Belegung von zu vielen Kursen:** wenn ihr gerade erst eure Schulzeit abgeschlossen habt, kann es sein, dass es euch komisch vorkommt, so wenige Kurse zu belegen. Besonders in unserem Studiengang unterschätzt man sehr, dass man zuhause viel vor- und nachbereiten muss. Macht euch also keinen Stress! Belegt in etwa so, wie es im Modulhandbuch steht.\n",
      "sluggedTitle": "tipps"
    }
  ]
}